import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { ColorsConstants } from "../cssUtils/constants";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: ColorsConstants.primaryBlue60,
        px: 2,
        textAlign: "center",
      }}
    >
      <ErrorOutlineIcon
        sx={{ fontSize: 72, color: ColorsConstants.primaryPurple110, mb: 2 }}
      />
      <Typography
        variant="h1"
        sx={{ fontSize: "6rem", fontWeight: 800, color: ColorsConstants.primaryBlue100, lineHeight: 1 }}
      >
        404
      </Typography>
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, color: ColorsConstants.primaryBlue100, mt: 1, mb: 1 }}
      >
        Page Not Found
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: "#666", maxWidth: 400, mb: 4 }}
      >
        The page you're looking for doesn't exist or may have been moved. Please
        check the URL or navigate back to a safe page.
      </Typography>
      <Stack direction="row" spacing={2}>
        <Button
          variant="contained"
          onClick={() => navigate("/")}
          sx={{
            backgroundColor: ColorsConstants.primaryPurple110,
            textTransform: "none",
            borderRadius: "8px",
            px: 3,
            "&:hover": { backgroundColor: ColorsConstants.primaryBlue100 },
          }}
        >
          Return to Dashboard
        </Button>
        <Button
          variant="outlined"
          onClick={() => window.history.back()}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            px: 3,
            borderColor: ColorsConstants.primaryPurple110,
            color: ColorsConstants.primaryPurple110,
            "&:hover": {
              borderColor: ColorsConstants.primaryBlue100,
              color: ColorsConstants.primaryBlue100,
            },
          }}
        >
          Go Back
        </Button>
      </Stack>
    </Box>
  );
};

export default NotFound;
